import {
  encryptPayload,
  decryptResponse,
  decryptAxiosData,
} from "../utils/apiEnvelope";
import { getNewAuthToken, isTokenExpired } from "../utils";
import axios from "../utils/axios";
import setAuthToken from "../utils/setAuthToken";
import { baseURL } from "../utils/url";
import { encrypt } from "../utils/encodingdecoding";

export const schema = async (token, type) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + "transactionSchema?schemaName=" + type,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const campaign = async (token, data) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "createCampaign", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(data),
    });
    const response = await decryptResponse(fetchResponse);

    return response;
  } catch (error) {
    return error;
  }
};

export const updateProfile = async (token, data) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "updateprofile", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(data),
    });
    const response = await decryptResponse(fetchResponse);

    return response;
  } catch (error) {
    return error;
  }
};

export const updatePassword = async (token, data) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "updatePassword", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(data),
    });
    const response = await decryptResponse(fetchResponse);

    return response;
  } catch (error) {
    return error;
  }
};

export const UpdateCampaign = async (token, data, campaigncode) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `updateCampaign?id=${campaigncode}`,
      {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: encryptPayload(data),
      },
    );
    const response = await decryptResponse(fetchResponse);

    return response;
  } catch (error) {
    return error;
  }
};

export const customerRegistration = async (token, data) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "customerRegistration", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: data,
    });
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const customerRegistrations = async (token, data) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "customerRegistration", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(data),
    });
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};
export const transactionRegistration = async (token, data) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "transactionManager", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: data,
    });
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const transactionRedeem = async (token, data) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "transactionRedeem", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: data,
    });
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const customerView = async (token, data) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        // console.log(res)
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `customerProfileData?customerCode=${encrypt(data)}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        // body: encryptPayload(data),
        id: data,
      },
    );
    const response = await decryptResponse(fetchResponse);

    return response;
  } catch (error) {
    return error;
  }
};

export const getTransactionEnquiry = async (token, data) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `transactionEnquiry?transactionId=${encrypt(data)}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        // body: encryptPayload(data),
        id: data,
      },
    );
    const response = await decryptResponse(fetchResponse);

    return response;
  } catch (error) {
    return error;
  }
};
export const getmerchantschema = async (token, data) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `getMerchantAllSchema?id=${encrypt(data)}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        // body: encryptPayload(data),
        id: data,
      },
    );
    const response = await decryptResponse(fetchResponse);

    return response;
  } catch (error) {
    return error;
  }
};

export const contactus = async (token, data) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "contactus", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(data),
    });
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const getVoucherTemplate = async (token) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "voucherTemplate", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const RedeemVoucher = async (token, body) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "redeemVoucher", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(body),
    });
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const getVoucherRedeemData = async (token) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "getVoucherRedeemData", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const getVoucherEnquiry = async (token, data) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `templateDetailsById?code=${encrypt(data)}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        // body: encryptPayload(data),
        code: data,
      },
    );
    const response = await decryptResponse(fetchResponse);

    return response;
  } catch (error) {
    return error;
  }
};

export const getVoucherTemplateByMerchantCode = async (token) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + "getVoucherTemplateByMerchant",
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const getVoucherTemplateStatusByCode = async (token, body) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "customerVouchers", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(body),
    });
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const createCustomer = async (token, body) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "createCustomerRecipients", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(body),
    });
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};
export const updateCustomer = async (token, body) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "updateContactRecipients", {
      method: "PATCH",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(body),
    });
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const getVouchersWallet = async (token, id, vouchertemplateCode) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL +
        `getVoucherWallet?merchantCode=${encrypt(id)}&vouchertemplateCode=${vouchertemplateCode ? encrypt(vouchertemplateCode) : ""}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const UpdateCustomerPortalData = async (
  token,
  isReciptUpload,
  inStoreRedeption,
  displayFirst,
  internal,
  external,
  isPointImg,
) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL +
        `updateCustomerPortal?isReciptUpload=${isReciptUpload}&inStoreRedeption=${inStoreRedeption}&displayFirst=${displayFirst}&internal=${internal}&external=${external}&isPointImg=${isPointImg}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};
export const UpdateUploadInVoiceData = async (
  token,
  invoiceId,
  IsApproved,
  Description,
  MerchantFeedback,
) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL +
        `updateInvoiceData?invoiceId=${invoiceId}&IsApproved=${IsApproved}&Description=${Description}&MerchantFeedback=${MerchantFeedback}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const merchantNotification = async (token, body, isAdmin) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL +
        `postMerchantNotificationAlert?isAdmin=${encrypt(String(isAdmin))}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: encryptPayload(body),
      },
    );
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const createCustomerSchema = async (token, body, schemaName) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `addCustomerSchema?schemaName=${encrypt(schemaName)}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: encryptPayload(body),
      },
    );
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};
export const updateCustomerSchema = async (token, body, merchantcode) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `updateCustomerSchema?merchantcode=${encrypt(merchantcode)}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: encryptPayload(body),
      },
    );
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const createTransactionSchema = async (
  token,
  body,
  schema,
  discriminator,
) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL +
        `addTransactionSchema?name=${encrypt(schema)}&discriminator=${encrypt(discriminator)}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: encryptPayload(body),
      },
    );
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};
export const updateTransactionSchema = async (
  token,
  body,
  merchantcode,
  schema,
) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL +
        `updateTransactionSchema?schema=${encrypt(schema)}&merchantcode=${encrypt(merchantcode)}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: encryptPayload(body),
      },
    );
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const getMerchantNotificationAlert = async (token) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + "getMerchantNotificationAlert",
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const getCustomerPortalSetting = async (token) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + `getCustomerPortalSetting`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteSendGridSMSSetting = async (token, merchantId, id) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });

    const fetchResponse = await fetch(
      baseURL +
        `deleteSendGridSMSSetting?merchantId=${encrypt(merchantId)}&id=${encrypt(id)}`,
      {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);

    return response;
  } catch (error) {
    return error;
  }
};

export const getEmailTemplateSetting = async (token, merCode) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `getEmailTemplateSetting?merchantCode=${encrypt(merCode)}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const smsSetting = async (token, body) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + `postSendGridSMSSetting`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(body),
    });
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const getSmsSetting = async (token, merCode) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `getSendGridSMSSetting?merCode=${merCode}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const generateQRTemplate = async (token, body) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + `generateQRCodeTemplate`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(body),
    });
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const generateQRCode = async (token, body) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + `generateQrcode`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(body),
    });
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const getQRTemplate = async (token, offset = 0, limit = 2000) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL +
        `getQrcodeTemplates?offset=${encrypt(String(offset))}&limit=${encrypt(String(limit))}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const socialProfileSetting = async (token, body) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + `postCustomerPortalSetting`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(body),
    });
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const getQRCode = async (token, merCode, template, page, limit) => {
  const valid = await isTokenExpired(token);

  try {
    if (!valid) {
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    }

    const params = new URLSearchParams({ merCode, page, limit });

    if (template) {
      params.append("qrTempCode", template);
    }

    const fetchResponse = await fetch(
      `${baseURL}getQrcodeByMerchantCode?${params.toString()}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );

    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const channelDashboard = async (token, id) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `getChannelPartnerDashboard?id=${id}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const getKYCData = async (token, id, offset, limit, searchValue) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL +
        `customerList?id=${encrypt(id)}&offset=${offset}&limit=${limit}&searchValue=${searchValue}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const getCustomerReceiptData = async (token) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + `getCustomerReceiptData`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateCustomerReceiptData = async (token, body) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + `updateCustomerReceiptData`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(body),
    });
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const updateQRStatus = async (token, id, status) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `updateUnitData?id=${encrypt(id)}&status=${encrypt(status)}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const payoutWithNovusAsync = async (token, body) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + `payoutWithNovusAsync`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(body),
    });
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const fileUpload = async (token, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res.access_token;
      });
    const fetchResponse = await fetch(baseURL + `fileUploadProcess`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        // Accept: "application/json",
      },
      body: formData,
    });
    return decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const getDynamicdata = async (token, key, value) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `getDynamicData?key=${encrypt(key)}&value=${encrypt(value)}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateDynamicData = async (token, body) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + `updateDynamicData`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(body),
    });
    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const checkCustomerPLPID = async (token, formData) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + `getCustomerData`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: encryptPayload(formData),
    });
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const getAllCustomer = async (
  token,
  discriminator,
  isMerchantId,
  container,
  key,
  value,
  key2,
  value2,
  page,
  limit,
) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL +
        `getDynamicAllData?discriminator=${encrypt(discriminator)}&isMerchantId=${encrypt(String(isMerchantId))}&container=${encrypt(container)}&key=${encrypt(key)}&value=${encrypt(value)}&key2=${encrypt(key2)}&value2=${encrypt(value2)}&page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const getQRCodeAllDataByQRTemplateCode = async (token, code, lot) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL +
        `getQRCodeAllDataByQRTemplateCode?code=${encrypt(code)}&lot=${encrypt(lot)}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const GetQRDataByCode = async (token, qrCode) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `GetQRDataByCode?qrCode=${encrypt(qrCode)}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const getQRTemplateData = async (token, code) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `getQRTemplateData?code=${encrypt(code)}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateQRTemplate = async (token, id, body) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `updateData?id=${encrypt(id)}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: encryptPayload(body),
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const getSupportData = async (token, offset, limit) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `getSupportData?offset=${offset}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};

export const getCustomer = async (token) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(baseURL + "customerSchema", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    return await decryptResponse(fetchResponse);
  } catch (error) {
    return error;
  }
};

export const getUserJourneyReport = async (token, id) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    setAuthToken(token);
    const headers = { "Content-Type": "application/json" };
    const fetchResponse = await axios.get(`dashboard?id=${id}`, {
      headers: headers,
    });
    return decryptAxiosData(fetchResponse?.data);
  } catch (error) {
    return error;
  }
};

export const getAllRedemption = async (token) => {
  const valid = await isTokenExpired(token);
  try {
    if (!valid)
      await getNewAuthToken().then((res) => {
        localStorage.setItem("token_gen", JSON.stringify(res));
        token = res?.access_token;
      });
    const fetchResponse = await fetch(
      baseURL + `getTransactionData?type=${encrypt("redeem")}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const response = await decryptResponse(fetchResponse);
    return response;
  } catch (error) {
    return error;
  }
};
